<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />

    
    <b-card class="bCardGlobal">
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Quejas</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>C-**</div>
        </b-col>
      </b-row>

      <div class="divSubtitulo">
        <p class="textSubtitulo">VoBo subdirección dental</p>
      </div>


      <div class="container-fluid main-component">
        <div class="row justify-content-center">
          <div class="col-sm-12 col-md-8 col-lg-5 col-xl-5">
            <b-card
              style="
                padding: 1%;
                width: 100%;
                border-radius: 20px;
                box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
              "
            >
              <p
                style="
                  text-align: left;
                  color: #093974;
                  font-size: 18px;
                  font-weight: 600;
                "
              >
                Información de la queja
              </p>
              <b-table-simple style="margin-top: 7%">
                <vue-custom-scrollbar
                  class="scroll-area"
                  :settings="settings"
                  @ps-scroll-y="scrollHanle"
                >
                  <tr>
                    <td style="font-size: 15px; text-align: left"><label>ID Paciente</label></td>
                    <td style="font-size: 15px">{{ datos.idPaciente }}</td>
                  </tr>
                  <tr>
                    <td style="font-size: 15px; text-align: left">
                      <label>Nombre del Paciente</label>
                    </td>
                    <td style="font-size: 15px">{{ datos.paciente }}</td>
                  </tr>
                  <tr>
                    <td style="font-size: 15px; text-align: left">
                      <label
                        >Tipo de Px (Nat o Plan) / para reforzar aviso a
                        comercial</label
                      >
                    </td>
                    <td style="font-size: 15px">{{ dictamen.idTipoPaciente }}</td>
                  </tr>
                  <tr>
                    <td style="font-size: 15px; text-align: left">
                      <label>Antigüedad del Px atendiéndose en Dentalia</label>
                    </td>
                    <td style="font-size: 15px;">{{ dictamen.antiguedad }}</td>
                  </tr>
                  <tr>
                    <td style="font-size: 15px; text-align: left">
                      <label
                        >Familiares o referidos atendiéndose en Dentalia</label
                      >
                    </td>
                    <td style="font-size: 15px">
                      {{ dictamen.antiguedad ? "Si" : "No" }}
                    </td>
                  </tr>
                  <tr>
                    <td style="font-size: 15px; text-align: left">
                      <label>Constancia de su atención (repetitivo)</label>
                    </td>
                    <td style="font-size: 15px">
                      {{ dictamen.recurrente ? "Si" : "No" }}
                    </td>
                  </tr>
                  <tr>
                    <td style="font-size: 15px; text-align: left">
                      <label>Historia</label>
                    </td>
                    <td
                    style="font-size: 15px; max-width: 10vw; overflow: auto"
                  >
                    <p v-if="dictamen.historia.length < 160">
                      {{ dictamen.historia }}
                    </p>
                    <b-button
                      v-else
                      title="Historia"
                      size="sm"
                      @click="
                        abrirModal(
                          'Historia de la queja',
                          'Información de la historia:',
                          dictamen.historia
                        )
                      "
                      variant="info"
                      ><em class="fa fa-eye"></em
                    ></b-button>
                  </td>
                  </tr>
                  <tr>
                    <td style="font-size: 15px; text-align: left">
                      <label>Monto total del PTI</label>
                    </td>
                    <td style="font-size: 15px">
                      {{ dictamen.montoPti | monedaEntero }}
                    </td>
                  </tr>
                  <tr>
                    <td style="font-size: 15px; text-align: left">
                      <label>¿Es imputable al doctor?</label>
                    </td>
                    <td style="font-size: 15px">
                      {{ dictamen.imputableDoctor ? "Si" : "No" }}
                    </td>
                  </tr>
  
                  <tr>
                    <td style="font-size: 15px; text-align: left">
                      <label>Sugerencia CC, ¿entra en garantía?</label>
                    </td>
                    <td style="font-size: 15px;max-width: 10vw; overflow: auto">
                      {{ dictamen.esGarantiaCC ? "Si" : "No" }}
                    </td>
                  </tr>
                  <tr>
                    <td style="font-size: 15px; text-align: left">
                      <label>Descripción de la sugerencia CC</label>
                    </td>
                    <td style="font-size: 15px">
                      <!-- {{dictamen.descripcionGarantiaCC}} -->
                      <p v-if="dictamen.descripcionGarantiaCC.length < 160">
                        {{dictamen.descripcionGarantiaCC}}
                      </p>
                      <b-button
                      v-else 
                      title="SugerenciaCC"
                      size="sm"
                      @click="abrirModal('Descripción de la sugerencia CC','Sugerencia CC:',dictamen.descripcionGarantiaCC)"
                      variant="info"
                  ><em class="fa fa-eye"></em></b-button>
                    </td>
                  </tr>
                  <tr>
                    <td style="font-size: 15px; text-align: left">
                      <label>Sugerencia CZ, ¿entra en garantía?</label>
                    </td>
                    <td style="font-size: 15px">
                      {{ dictamen.esGarantiaCZ ? "Si" : "No" }}
                    </td>
                  </tr>
                  <tr>
                    <td style="font-size: 15px; text-align: left">
                      <label>Descripción de la sugerencia CZ</label>
                    </td>
                    
                    <td style="font-size: 15px;">
                     
                      <p v-if="dictamen.descripcionGarantiaCZ.length < 160">
                        {{dictamen.descripcionGarantiaCZ}}
                      </p>
                      <b-button
                      v-else 
                      title="SugerenciaCZ"
                      size="sm"
                      @click="abrirModal('Descripción de la sugerencia CZ','Sugerencia CZ:',dictamen.descripcionGarantiaCZ)"
                      variant="info"
                  ><em class="fa fa-eye"></em></b-button>
                    </td>
                  </tr>
                </vue-custom-scrollbar>
              </b-table-simple>
              <div style="margin-top: 10%">
                <p>
                  A través de <strong>{{ datos.origen }}</strong> el paciente
                  comenta:
                </p>
                <p v-if="datos.comentarios.length < 160">
                  <strong>{{ datos.comentarios }}</strong>
                </p>
                <b-button
                  variant="info"
                  v-else
                  @click="
                    abrirModal(
                      'Comentarios del paciente',
                      'El paciente comenta:',
                      datos.comentarios
                    )
                  "
                  >Ver comentarios</b-button
                >
              </div>
            </b-card>
          </div>

          <div class="col-sm-12 col-md-12 col-lg-7 col-xl-7">
            <div class="container-fluid main-component" style="margin-top: 3%">
              <div class="row justify-content-between">
                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <p
                    style="
                      text-align: left;
                      color: #093974;
                      font-size: 18px;
                      font-weight: 600;
                    "
                  >
                    Tratamientos realizados
                  </p>
                  <div v-if="sesiones.length > 0">
                    <vue-custom-scrollbar
                        class="scroll-area-tx"
                        :settings="settings"
                        @ps-scroll-y="scrollHanle"
                    >
                    <div v-for="item in sesiones" :key="'tx' + item.idTratamientoProgramado"
                    >
                      <b-card
                          
                          style="padding: 2%; box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px"
                          v-if="item.tratamiento != 'Sin Dato'"
                      >
                        <div class="row">
                          <div class="col-3">   
                            <img
                            width="100%"
                            style="max-width: 100%"
                            src="../../../assets/icons/tratamiento.png"
                        />
                          </div>
                          <div class="col-9" style="text-align:left">
                            <p style="margin: 4%"><label>Tx:</label>{{ item.tratamiento }}</p>
                            <p style="margin: 4%"><label>Num. sesión:</label>{{ item.numeroSesion }}</p>
                            <p style="margin: 4%"><label>OD:</label>{{ item.numeroDiente }}</p>
                          </div>
                         
                        </div>
                        <div>
                          

                        </div>

                      </b-card>
                    </div>
                      
                    </vue-custom-scrollbar>
                  </div>
                  <div v-else>
                    <b-card
                        style="
                    padding: 2%;
                    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
                  "
                    >
                    <div class="row" >
                      <div class="col-3">   
                        <img
                        width="50px"
                        style="max-width: 100%"
                        src="../../../assets/icons/tratamiento.png"
                    />
                      </div>
                      <div class="col-9" style="text-align:left">
                        <p style="margin: 4%">No se encontraron tratamientos</p>
                      </div>
                    </div>
                      
                    </b-card>

                  </div>
                  </div>

                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <p
                    style="
                      text-align: left;
                      color: #093974;
                      font-size: 18px;
                      font-weight: 600;
                      margin-top: 3%;
                    "
                  >
                    Tratamientos por realizar
                  </p>
                  <div
                    v-if="datosAdicionales.tratamientosPorRealizar.length > 0"
                  >
                  <vue-custom-scrollbar
                  class="scroll-area-tx"
                  :settings="settings"
                  @ps-scroll-y="scrollHanle"
              >
                <b-card
                    v-for="item in datosAdicionales.tratamientosPorRealizar"
                    :key="'tx' + item.idTratamientoProgramado"
                    style="padding: 2%; box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px"
                >
                <div class="row">
                  <div class="col-3">   
                    <img
                        width="100%"
                        style="max-width: 100%"
                        src="../../../assets/icons/tratamiento.png"
                    />
                  </div>
                  <div class="col-9" style="text-align:left"> 
                    <p style="margin: 4%"><label>Tx:</label>{{ item.tratamiento }}</p>
                   

                  </div>
                </div>
                 
                </b-card>
              </vue-custom-scrollbar>
                  </div>
                  <div v-else>
                    <b-card
                      style="
                        padding: 2%;
                        box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
                      "
                    >
                      <div
                        style="display: flex; flex-direction: row; width: 100%"
                      >
                        <img
                          width="50px"
                          style="max-width: 100%"
                          src="../../../assets/icons/tratamiento.png"
                        />
                        <p style="margin: 4%">No se encontraron tratamientos</p>
                      </div>
                    </b-card>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid main-component" style="margin-bottom: 3%">
        <p
          style="
            text-align: left;
            color: #093974;
            font-size: 18px;
            font-weight: 600;
            margin-top: 3%;
          "
        >
          Información
        </p>
        <div
        style="
          display: flex;
          flex-direction: row;
          width: 100%;
          margin-top: 3%;
        "
      >
        <div class="divInput" style="width: 100%">
          <b-form-group align="left">
            <label>¿Entra en garantía?</label>
            <v-select
              :options="select"
              label="text"
              :reduce="(fin) => fin.value"
              v-model="$v.dictamen.esGarantiaVO.$model"
              :state="validateState('esGarantiaVO')"
            >
              >
            </v-select>
          </b-form-group>
        </div>
        <div class="divInput" style="width: 100%">
          <b-form-group align="left">
            <label>Razón</label>
            <b-form-textarea
              v-model="$v.dictamen.razon.$model"
              :state="validateState('razon')"
            >
              >
            </b-form-textarea>
          </b-form-group>
        </div>
      </div>
        <div style="margin-top: 3%">
          <b-button variant="outline-primary" :disabled="loaderGuardar" @click="guardar()">
            <span v-if="!loaderGuardar">Guardar</span>
            <span v-if="loaderGuardar">
                    <b-spinner small></b-spinner>
                Cargando...
                </span>
          </b-button>
        </div>
      </div>
      <b-modal
        v-model="modalComentarios"
        :title="tituloModal"
        scrollable
        size="lg"
      >
        <p style="font-size: 18px; font-weight: 600">{{ subtituloModal }}</p>
        <div class="container-fluid main-component p-3 text-justify">
          <p>{{ cuerpoModal }}</p>
        </div>
      </b-modal>
    </b-card>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import Header from "../../../components/Header";
import { GarantiaService } from "../../../apiServices/garantias/GarantiaService";
import { CatalogosService } from "../../../apiServices/catalogos/CatalogosService";
import vueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";
export default {
  name: "dicatamenOperativo",
  components: { Header, vueCustomScrollbar },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      settings: {
        suppressScrollY: false,
        suppressScrollX: false,
        wheelPropagation: false,
      },
      garantiaServicio: new GarantiaService(),
      catalogoServicio: new CatalogosService(),
      select: [
        { value: true, text: "Si" },
        { value: false, text: "No" },
      ],
      modalComentarios: false,
      idTicket: null,
      idEtapa: null,
      tipos: [],
      loaderGuardar: false,

      datos: {
        origen: "",
        comentarios: "",
        idPaciente: "",
        paciente: "",
        driver: "",
        tema: "",
        subtema: "",
      },
      datosAdicionales: null,
      dictamen: {
        idDictamnOperaciones: null,
        idTipoPaciente: null,
        idSolicitud: null,
        idTipoPanciente: null,
        antiguedad: null,
        familiares: null,
        recurrente: null,
        historia: null,
        montoPti: null,
        imputableDoctor: null,
        esGarantiaCC: null,
        descripcionGarantiaCC: null,
        esGarantiaCZ: null,
        descripcionGarantiaCZ: null,
      },
      cuerpoModal: "",
      tituloModal: "",
      subtituloModal: "",
      sesiones: []

    };
  },
  validations: {
      dictamen: {
        esGarantiaVO: { required },
        razon: { required },
      },
    },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.idTicket = this.$route.params.id;
    this.idEtapa = this.$route.params.idEtapa;
    this.obtenerDictamen();
    this.obtenerInformacionTicket();
  },
  methods: {
    obtenerSesiones(){
    const parametros = {idPaciente: this.datos.idPaciente}
      this.$http.post(this.$api + "tratamiento_sesion/obtenerSesionesRealizadas", parametros)
         .then((response) => {
           if(response.data.data){
           this.sesiones = response.data.data;
             }
         }).catch(function(error){
           console.error(error);
           this.loaderTratamientossesion = false;
         });
    },
    abrirModal(titulo, subtitulo, cuerpo) {
      this.cuerpoModal = cuerpo;
      this.subtituloModal = subtitulo;
      this.tituloModal = titulo;
      this.modalComentarios = true;
    },
    obtenerInformacionTicket() {
      const parametros = {idTicket: this.idTicket}
      this.garantiaServicio.obtenerTicket(parametros).then((respuesta) => {
        this.datos = respuesta.data;
        this.obtenerDatosAdicionales();
        this.obtenerSesiones();
      });
    },
    obtenerDatosAdicionales() {
      const parametros = {idPaciente: this.datos.idPaciente}
      this.garantiaServicio
        .obtenerDatosAdicionales(parametros)
        .then((respuesta) => {
          this.datosAdicionales = respuesta.data;
        });
    },
    obtenerDictamen() {
      const parametros = {idSolicitud: this.idTicket}
      this.garantiaServicio.obtenerDictamen(parametros).then((respuesta) => {
        this.dictamen = respuesta.data;
      });
    },
    guardar(listaGarantias) {
        this.$v.dictamen.$touch();
        if (this.$v.dictamen.$anyError) {
          return false;
        }
        this.loaderGuardar = true;
        const envio = JSON.parse(JSON.stringify(this.dictamen));
        envio.garantias = listaGarantias
        envio.idEtapa = this.idEtapa
        this.garantiaServicio
          .actualizarDictamen(envio )
          .then(() => {
            this.$swal({
              icon: "success",
              title: "Se registro correctamente",
              showConfirmButton: false,
            });
            this.$v.$reset();
            window.history.back();
          })
          .finally(() => {
            this.loaderGuardar = false;
          });
      },
    validateState(name) {
        const { $dirty, $error } = this.$v.dictamen[name];
        return $dirty ? !$error : null;
      },
      selectClass(attribute) {
        let state = this.validateState(attribute);
        if (state) {
          return "border rounded-lg border-success";
        } else if (state === false) {
          return "border rounded-lg border-danger";
        } else {
          return "";
        }
      },
  },
};
</script>

<style scoped>
.bCardGlobal {
  margin: 2% 4% 2% 4%;
  padding: 0.5% 1% 0.5% 1%;
  border-radius: 20px;
}

.divSubtitulo {
  width: 100%;
  margin-top: 2%;
  border-bottom: 5px solid #8ec6e9;
}

.divInput {
  margin-left: 1%;
  margin-right: 3%;
}

.textSubtitulo {
  color: #093974;
  font-weight: 600;
  font-size: 22px;
  text-align: left;
}

.overflow-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.scroll-area {
  position: relative;
  margin: auto;
  height: 320px;
}

.scroll-area-tx {
  position: relative;
  margin: auto;
  height: 500px;
}
</style>
